var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-close"},[_c('span',{staticClass:"mc__inner"},_vm._l((2),function(index){return _c('span',{key:("li" + index),staticClass:"mc__line"})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }